.field {
  align-items: center;
  display: inline-flex;
  gap: var(--pgm-sys-spacing-2);
}

.labelStart {
  flex-direction: row-reverse;
}

.checkbox {
  --md-checkbox-container-shape: 2px;
  --md-checkbox-container-size: 18px;
  --md-checkbox-outline-color: var(--pgm-sys-color-on-surface-variant);
  --md-checkbox-hover-outline-color: var(--pgm-sys-color-on-surface);
  --md-checkbox-focus-outline-color: var(--pgm-sys-color-on-surface);
  --md-checkbox-selected-container-color: var(--pgm-sys-color-primary);
  --md-checkbox-selected-hover-container-color: var(--pgm-sys-color-primary);
  --md-checkbox-selected-focus-container-color: var(--pgm-sys-color-primary);
  --md-checkbox-selected-pressed-container-color: var(--pgm-sys-color-primary);
  --md-checkbox-selected-icon-color: var(--pgm-sys-color-on-primary);
  --md-checkbox-selected-hover-icon-color: var(--pgm-sys-color-on-primary);
  --md-checkbox-selected-focus-icon-color: var(--pgm-sys-color-on-primary);
  --md-checkbox-hover-state-layer-color: var(--pgm-sys-color-on-surface);
  --md-checkbox-selected-hover-state-layer-color: var(--pgm-sys-color-primary);
  --md-focus-ring-color: var(--pgm-sys-color-secondary);
  --md-focus-ring-width: 3px;
}

.label {
  color: var(--pgm-sys-color-on-surface);
  cursor: pointer;
  margin: 0;
}
